<div [class]="
    stacked
      ? 'app-search-results-sort-select app-search-results-sort-select--stacked'
      : 'app-search-results-sort-select'
  ">
  <label class="app-search-results-sort-select__label">{{ label }} </label>
  <div class="app-search-results-sort-select__select">
    <trap-focus [enableFocusTrap]="enableFocusTrap" [enableArrowKeys]="true">
      <app-dropdown-select [items]="sellSortService.sortOptions$ | async" label="sort by" (openChange)="onOpenChange($event)"
        (click)="updateSort($event.target)"></app-dropdown-select>
    </trap-focus>
  </div>
</div>
